import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  assignmentDrawer: {
    width: "350px",
    marginTop: "60px",
    padding: "10px",
  },
  filterButton: {
    float: "right",
    marginTop: "15px",
    textTransform: "none",
  },
  clearButton: {
    float: "right",
    marginTop: "15px",
    marginLeft: "10px",
    textTransform: "none",
  },
  title: {
    margin: "15px 0",
  },
}));

const AssigmentFilterModal = (props) => {
  const {
    drawerFilterValue,
    organizationList,
    serviceList,
    serviceTypeList,
    dropDownValue,
    setDropDownValue,
    handleDrawer,
    setDrawerFilterValue,
    filterModal,
    role,
  } = props;
  const classes = useStyles();

  const handleDropDownValue = (event) => {
    const { name, value } = event?.target;
    setDropDownValue((oldValue) => ({ ...oldValue, [name]: value }));
  };

  const handleApplyFilter = () => {
    setDrawerFilterValue(dropDownValue);
    handleDrawer(false);
  };

  const handleClearFilter = () => {
    setDrawerFilterValue(null);
    setDropDownValue(null);
    handleDrawer(false);
  };

  return (
    <SwipeableDrawer
      anchor={"right"}
      open={filterModal}
      onClose={() => {
        handleDrawer(false);
      }}
    >
      <div className={classes.assignmentDrawer}>
        {role === "admin" && (
          <>
            <Typography
              variant="subtitle1"
              style={{ color: "#EF7000", fontWeight: 700 }}
            >
              Organization
            </Typography>
            <Select
              defaultValue={dropDownValue?.organization || "all"}
              labelId="organization"
              id="organization"
              name="organization"
              autoFocus
              placeholder={"Organization"}
              onChange={handleDropDownValue}
              value={drawerFilterValue?.organization}
              variant="outlined"
              style={{ width: "100%", marginBottom: "12px" }}
            >
              {organizationList?.length && (
                <MenuItem key="all" value="all">
                  All
                </MenuItem>
              )}
              {organizationList?.length &&
                organizationList?.map((data, index) => {
                  return (
                    <MenuItem
                      name={data.organisation_name}
                      key={index}
                      value={data.organisation_name}
                    >
                      <Typography variant="h2">
                        {data.organisation_name}
                      </Typography>
                    </MenuItem>
                  );
                })}
            </Select>
          </>
        )}
        <Typography
          variant="subtitle1"
          style={{ color: "#EF7000", fontWeight: 700 }}
        >
          Service
        </Typography>
        <Select
          defaultValue={dropDownValue?.service_type || "all"}
          labelId="service_type"
          id="service_type"
          name="service_type"
          placeholder={"Service Type"}
          onChange={handleDropDownValue}
          value={drawerFilterValue?.service_type}
          variant="outlined"
          style={{ width: "100%", marginBottom: "12px" }}
        >
          {serviceTypeList?.length && (
            <MenuItem key="all" value="all">
              All
            </MenuItem>
          )}
          {serviceTypeList?.length &&
            serviceTypeList?.map((data, index) => {
              return (
                <MenuItem name={data?.name} key={index} value={data?.name}>
                  <Typography variant="h2">{data?.value}</Typography>
                </MenuItem>
              );
            })}
        </Select>
        <Typography
          variant="subtitle1"
          style={{ color: "#EF7000", fontWeight: 700 }}
        >
          Service type
        </Typography>
        <Select
          defaultValue={dropDownValue?.service || "all"}
          labelId="service"
          id="service"
          name="service"
          placeholder={"Service"}
          onChange={handleDropDownValue}
          value={drawerFilterValue?.service}
          variant="outlined"
          style={{ width: "100%", marginBottom: "12px" }}
        >
          {serviceList?.length && (
            <MenuItem key="all" value="all">
              All
            </MenuItem>
          )}
          {serviceList?.length &&
            serviceList?.map((data, index) => {
              return (
                <MenuItem name={data} key={index} value={data}>
                  <Typography variant="h2">{data}</Typography>
                </MenuItem>
              );
            })}
        </Select>
        <Button
          className={classes.clearButton}
          color="secondary"
          variant="contained"
          onClick={handleApplyFilter}
        >
          Apply
        </Button>
        <Button
          className={classes.filterButton}
          color="info"
          variant="contained"
          onClick={handleClearFilter}
        >
          Cancel
        </Button>
      </div>
    </SwipeableDrawer>
  );
};

export default AssigmentFilterModal;
